__turbopack_context__.v({
  "actions": "AddPatient-module__mouL1G__actions",
  "container": "AddPatient-module__mouL1G__container",
  "noPractitionerContainer": "AddPatient-module__mouL1G__noPractitionerContainer",
  "noPractitionerText": "AddPatient-module__mouL1G__noPractitionerText",
  "noPractitionerTitle": "AddPatient-module__mouL1G__noPractitionerTitle",
  "row": "AddPatient-module__mouL1G__row",
});
